// UserInfoModal.jsx 🎨 Harmonised with Profile
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import axios from "axios";
import "./styles/UserInfoModal.css";

// 🇺🇳 Convert ISO code to Twemoji flag
const countryToTwemoji = (code) => {
  if (!code) return "1f3f3f";
  return [...code.toUpperCase()]
    .map((c) => 127397 + c.charCodeAt())
    .map((cp) => cp.toString(16))
    .join("-");
};

const UserInfoModal = ({ displayName, show, onHide }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (show && displayName) {
      setLoading(true);
      axios
        .get(`/api/user_info.php?display_name=${encodeURIComponent(displayName)}`)
        .then((res) => setUser(res.data))
        .catch(() => setUser(null))
        .finally(() => setLoading(false));
    }
  }, [show, displayName]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      dialogClassName="modal-dialog-centered user-info-modal"
    >
      <div className="modal-content profile-section p-0">
        {/* Header */}
        <div className="modal-header border-bottom border-secondary px-4 py-3">
          <h5 className="modal-title">
            <i className="bi bi-person-circle me-2 text-corange"></i> User Info
          </h5>
          <button type="button" className="btn-close btn-close-white" onClick={onHide} />
        </div>

        {/* Body */}
        <div className="modal-body px-4 py-4">
          {loading ? (
            <p className="text-muted text-center">Loading...</p>
          ) : user ? (
            <div className="text-center">
              {/* Avatar */}
              <div className="avatar-clickable mx-auto mb-3" style={{ pointerEvents: "none" }}>
                <img
                  src={user.avatar_url || "/img/avatar_default.jpg"}
                  alt="User Avatar"
                  className="profile-avatar-img"
                />
              </div>

              {/* Display Name + Flag */}
              <div className="profile-name d-flex justify-content-center align-items-center gap-2 mb-1">
                {user.display_name}
                {user.location && (
                  <img
                    src={`https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${countryToTwemoji(user.location)}.svg`}
                    alt={user.location}
                    className="flag-icon"
                    style={{ width: "28px", height: "20px" }}
                  />
                )}
              </div>

              {/* Job Title */}
              <div className="profile-role mb-3">
                {user.job_title || "—"}
              </div>

              {/* Info Section */}
              <div className="profile-info text-start">
                <div className="info-row">
                  <span>Phone</span>
                  <span>
                    <a
                      href={`tel:${user.phone_number}`}
                      className="text-light text-decoration-underline"
                    >
                      {user.phone_number || "—"}
                    </a>
                  </span>
                </div>
                <div className="info-row">
                  <span>Email</span>
                  <span>
                    <a
                      href={`mailto:${user.email}`}
                      className="text-light text-decoration-underline"
                    >
                      {user.email || "—"}
                    </a>
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <p className="text-danger text-center">User not found.</p>
          )}
        </div>

        {/* Footer */}
        <div className="modal-footer border-top border-secondary justify-content-end px-4 py-3">
          <button type="button" className="btn-profile" onClick={onHide}>
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default UserInfoModal;
